import { Select } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import QuoteStore from '../../stores/QuoteStore';

let busy: any = null;

export const Users = observer((props: any) => {
    const searchOwners = (search = '') => {
        QuoteStore.getUsers({
            search: search,
            is_staff: true,
        });
    };

    useEffect(() => {
        searchOwners('');
    }, []);

    const users = QuoteStore.users;

    return (
        <Select
            showSearch
            allowClear
            labelInValue
            placeholder="Search user by name or email"
            filterOption={false}
            optionKeyProp={'value'}
            dropdownMatchSelectWidth={false}
            style={{ width: '100%' }}
            onSearch={name => {
                if (busy) {
                    clearTimeout(busy);
                }

                busy = setTimeout(() => searchOwners(name), 500);
            }}
            {...props}
        >
            {users.map(d => (
                <Select.Option key={d.id}>{d.fullname}</Select.Option>
            ))}
        </Select>
    );
});
